import React, { useEffect, useState } from "react";

const EventsSection = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://immaculatenursingkkl.org/iihs/api/get_events.php")
      .then((res) => res.json())
      .then((data) => {
        setEvents(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching events:", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading events...</p>;
  if (events.length === 0)
    return <p>No events found. Please add events from the admin panel.</p>;

  const mainEvent = events[0]; // First / latest event
  const nextEvents = events.slice(1, 4); // Next 3 events

  return (
    <section className="events-section gdlr-core-pbf-sidebar-container gdlr-core-container" style={{ padding: "40px 20px" }}>
      {/* Section Title */}
      <h2
        style={{
          textAlign: "center",
          fontSize: "28px",
          fontWeight: "bold",
          color: "#18489d",
          marginBottom: "40px",
        }}
      >
        Events and Functions
      </h2>

      <div
        className="events-container"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "30px",
          alignItems: "flex-start",
        }}
      >
        {/* Left Side: Main Event */}
        {mainEvent && (
          <div
            className="main-event"
            style={{ flex: "1 1 10%", minWidth: "300px" }}
          >
            <img
              src={`https://immaculatenursingkkl.org/iihs/admin/${mainEvent.image}`}
              alt={mainEvent.title}
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "8px",
                marginBottom: "20px",
              }}
            />
            <h3 style={{ color: "#18489d" }}>{mainEvent.title}</h3>
            <p style={{ lineHeight: "1.6", marginTop: "10px" }}>
              {mainEvent.description}
            </p>
          </div>
        )}

        {/* Right Side: Smaller Event List */}
        <div
          className="events-list"
          style={{ flex: "1 1 40%", minWidth: "250px" }}
        >
          {nextEvents.map((event) => (
            <div
              key={event.id}
              className="event-item"
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "20px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                background: "#fff",
              }}
            >
              <div
                className="event-date"
                style={{
                  textAlign: "center",
                  marginRight: "15px",
                  minWidth: "60px",
                }}
              >
                <h4
                  style={{
                    margin: 0,
                    fontSize: "20px",
                    color: "#b30000",
                    fontWeight: "bold",
                  }}
                >
                  {new Date(event.date).getDate()}
                </h4>
                <small style={{ textTransform: "uppercase" }}>
                  {new Date(event.date).toLocaleString("default", {
                    month: "short",
                  })}
                </small>
              </div>
              <div className="event-info">
                <h5 style={{ margin: "0 0 5px", color: "#18489d" }}>
                  {event.title}
                </h5>
                <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                  {event.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* View All Events Link */}
      <div style={{ textAlign: "center", marginTop: "30px" }}>
        <a
          href="/all-events"
          style={{
            textDecoration: "none",
            color: "#fff",
            backgroundColor: "#18489d",
            padding: "10px 20px",
            borderRadius: "5px",
          }}
        >
          View All Events
        </a>
      </div>
    </section>
  );
};

export default EventsSection;
